import { Fragment, React, useState } from 'react';
import Error from './Error';
import PropTypes from 'prop-types';

const Presupuesto = ({
  guardarPresupuesto,
  guardarRestante,
  cambiarEstadoMostrarFormularioPresupuesto,
}) => {
  // state para guardar presupuesto
  const [cantidad, guardarCantidadDefinidaPresupuesto] = useState(0);

  // state para guardar error
  const [error, guardarError] = useState(false);

  //Funcion que lee presupuesto
  const leerPresupuesto = (e) => {
    guardarCantidadDefinidaPresupuesto(parseInt(e.target.value), 10);
  };

  //Agregar presupuesto
  const agregarPresupuesto = (e) => {
    e.preventDefault();

    console.log('eeee', isNaN(cantidad));

    // validaciones
    if (cantidad < 1 || isNaN(cantidad)) {
      guardarError(true);
      return;
    }

    // establece valores de presupuesto y restante
    guardarError(false);
    guardarPresupuesto(cantidad);
    guardarRestante(cantidad);
    cambiarEstadoMostrarFormularioPresupuesto(false);
  };

  return (
    <Fragment>
      <h2>Define tu Presupuesto</h2>

      {error ? <Error mensaje='El presupuesto definido es incorrecto' /> : ''}

      <form onSubmit={agregarPresupuesto}>
        <input
          type='number'
          className='u-full-width'
          placeholder='Coloca tu presupuesto'
          onChange={leerPresupuesto}
        />

        <input
          type='submit'
          className='u-full-width button-primary'
          value='Definir presupuesto'
        ></input>
      </form>
    </Fragment>
  );
};

Presupuesto.propTypes = {
  guardarPresupuesto: PropTypes.func.isRequired,
  guardarRestante: PropTypes.func.isRequired,
  cambiarEstadoMostrarFormularioPresupuesto: PropTypes.func.isRequired,
};

export default Presupuesto;
